jQuery(function() {

  var setState = function(element, country, existingValue){
    existingValue = existingValue ? existingValue : element.val();
    jQuery.get(
      '/country/'+ country +'/states',
      data => {
        // if (data.results.length > 0){
          element.html('');
        // }
        if (existingValue) {
          if (!data.results.find(function(a){ return a.id == existingValue }) ){
            data.results.push({id: existingValue, text: existingValue })
          }
        }
        element.select2({
          data: data.results,
          allowClear: true,
          language: {
            noResults: function() {
              return 'No values found. You can type in your custom value';
            },
          },
          tags: true
        });
        element.val(existingValue).trigger("change");
      }
    );
  }

  var setCity = function(element, country, existingValue){
    existingValue = existingValue ? existingValue : element.val();
    jQuery.get(
      '/country/'+ country +'/cities/',
      data => {
        // if (data.results.length > 0){
          element.html('');
        // }

        if (existingValue) {
          if (!data.results.find(function(a){ return a.id == existingValue }) ){
            data.results.push({id: existingValue, text: existingValue })
          }
        }
        element.select2({
          data: data.results,
          allowClear: true,
          language: {
            noResults: function() {
              return 'No values found. You can type in your custom value';
            },
          },
          tags: true
        });
        element.val(existingValue).trigger("change");
      }
    );
  }

  jQuery('.country').each(function(){
    jQuery(this).select2({
        allowClear: true,
        include_hidden: false
    });

    if ( this.value ){
      setCity(jQuery('.city[data-group="' + this.dataset.group + '"]'), this.value, jQuery('.city[data-group="' + this.dataset.group + '"]').val());
      setState(jQuery('.state[data-group="' + this.dataset.group + '"]'), this.value, jQuery('.state[data-group="' + this.dataset.group + '"]').val());
    }
  });

  //County Changed
  jQuery('.country').on("change", function (ele) {
    var stateSel = jQuery('.state[data-group="' + this.dataset.group + '"]'),
        citySel = jQuery('.city[data-group="' + this.dataset.group + '"]');

    stateSel.val(null).trigger('change');
    citySel.val(null).trigger('change');
    if (this.selectedIndex < 1){
      stateSel.select2();
      citySel.select2()
      return; //done
    }
    setState(stateSel, this.value);
    setCity(citySel, this.value);
  });


  jQuery('.country').on("select2:clear", function () {
    var stateSel = jQuery('.state[data-group="' + this.dataset.group + '"]'),
        citySel = jQuery('.city[data-group="' + this.dataset.group + '"]');

    stateSel.val(null).trigger('change');
    citySel.val(null).trigger('change');
  });

  jQuery(".copy-address").change(function() {
    if (this.checked){
      jQuery('.country[data-group="' + this.dataset.group + '"]').val( jQuery('.country[data-group="' + this.dataset.fromGroup + '"]').val() ).trigger('change');

      jQuery('.line1[data-group="' + this.dataset.group + '"]').val( jQuery('.line1[data-group="' + this.dataset.fromGroup + '"]').val() );

      jQuery('.line2[data-group="' + this.dataset.group + '"]').val( jQuery('.line2[data-group="' + this.dataset.fromGroup + '"]').val() );

      jQuery('.postal_code[data-group="' + this.dataset.group + '"]').val( jQuery('.postal_code[data-group="' + this.dataset.fromGroup + '"]').val() );

      setCity(jQuery('.city[data-group="' + this.dataset.group + '"]'), jQuery('.country[data-group="' + this.dataset.fromGroup + '"]').val(), jQuery('.city[data-group="' + this.dataset.fromGroup + '"]').val() );

      setState(jQuery('.state[data-group="' + this.dataset.group + '"]'), jQuery('.country[data-group="' + this.dataset.fromGroup + '"]').val(), jQuery('.state[data-group="' + this.dataset.fromGroup + '"]').val() );
    }
  }).change();
});
